"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _react2 = require("swiper/react");
var _styles = require("@material-ui/core/styles");
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _fslightboxReact = _interopRequireDefault(require("fslightbox-react"));
var _image = _interopRequireDefault(require("../../helper/image"));
var _resolveImage = _interopRequireDefault(require("../../utils/resolveImage"));
require("swiper/swiper.scss");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(theme => {
  var _theme$shape;
  return {
    imageWrapper: {
      cursor: "pointer",
      "& img": {
        borderRadius: (_theme$shape = theme.shape) === null || _theme$shape === void 0 ? void 0 : _theme$shape.borderRadius,
        display: "block",
        maxWidth: "100%",
        width: "100%"
      }
    }
  };
});
const Gallery = _ref => {
  let {
    data
  } = _ref;
  const {
    REACT_APP_PATH
  } = process.env;
  const {
    elements = []
  } = data;
  const css = useStyles();
  const [lightboxController, setLightboxController] = _react.default.useState({
    toggler: false,
    slide: 1
  });
  if (elements.length === 0) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  const bigImages = elements.map(item => {
    var _item$media, _item$media2;
    return ((item === null || item === void 0 || (_item$media = item.media) === null || _item$media === void 0 || (_item$media = _item$media[0]) === null || _item$media === void 0 ? void 0 : _item$media.filename.charAt(0)) === "/" ? REACT_APP_PATH : "") + (item === null || item === void 0 || (_item$media2 = item.media) === null || _item$media2 === void 0 || (_item$media2 = _item$media2[0]) === null || _item$media2 === void 0 ? void 0 : _item$media2.filename);
  });
  const thumbnails = elements.filter(item => {
    var _item$media3;
    return item === null || item === void 0 || (_item$media3 = item.media) === null || _item$media3 === void 0 || (_item$media3 = _item$media3[0]) === null || _item$media3 === void 0 ? void 0 : _item$media3.subFormats;
  }).map(item => {
    var _item$media4;
    return (0, _lodash.first)((0, _resolveImage.default)(item === null || item === void 0 || (_item$media4 = item.media) === null || _item$media4 === void 0 || (_item$media4 = _item$media4[0]) === null || _item$media4 === void 0 ? void 0 : _item$media4.subFormats, "basic-gallery-thumb"));
  });
  const openLightboxOnSlide = slideNumber => {
    setLightboxController({
      toggler: !lightboxController.toggler,
      slide: slideNumber + 1
    });
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, thumbnails && /*#__PURE__*/_react.default.createElement(_Box.default, {
    my: 6
  }, /*#__PURE__*/_react.default.createElement(_react2.Swiper, {
    breakpoints: {
      0: {
        slidesPerView: 2
      },
      600: {
        slidesPerView: 4
      }
    },
    className: css.root,
    spaceBetween: 6
  }, thumbnails.map((tile, counter) => {
    return /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide, {
      className: css.imageWrapper,
      key: tile.filename,
      onClick: () => openLightboxOnSlide(counter)
    }, /*#__PURE__*/_react.default.createElement(_image.default, {
      itemStyle: css.image,
      filename: (tile === null || tile === void 0 ? void 0 : tile.filename) && ((tile === null || tile === void 0 ? void 0 : tile.filename.charAt(0)) === "/" ? REACT_APP_PATH : "") + (tile === null || tile === void 0 ? void 0 : tile.filename),
      height: tile === null || tile === void 0 ? void 0 : tile.height,
      width: tile === null || tile === void 0 ? void 0 : tile.width,
      alt: ""
    }));
  })), /*#__PURE__*/_react.default.createElement(_fslightboxReact.default, {
    toggler: lightboxController.toggler,
    sources: bigImages,
    slide: lightboxController.slide
  })));
};
var _default = exports.default = Gallery;